import React from 'react';
import { View, Text } from 'react-native';
import StudentListScreen from '../../src/screens/progress/StudentListScreen';
import { useTabAccess } from '../../src/hooks/useTabAccess';

export default function StudentsRoute() {
  const { showStudents } = useTabAccess();

  if (!showStudents) {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <Text style={{ fontSize: 18, fontWeight: '600', color: '#1f2937', textAlign: 'center' }}>
          Student insights are only available for school administrators.
        </Text>
      </View>
    );
  }
  return <StudentListScreen />;
}
